module.exports = __webpack_public_path__ + "static/media/clarinet.1f82cc20.svg";